import { Theater, ExternalLink } from 'lucide-react';

const PrincessWhatsOnSection = () => {
  return (
    <div className="content-card" data-testid="princess-whatson-section">
      <div className="card-header">
        <h2>
          <Theater size={20} className="inline" /> Princess Theatre
        </h2>
      </div>
      <div className="card-content whatson-content">
        <div className="whatson-container">
          <p className="whatson-description">
            Hunstanton's theatre presenting shows, music, comedy and family entertainment.
          </p>
          <a 
            href="https://www.princesshunstanton.co.uk/browse" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatson-link-btn"
          >
            <Theater size={18} />
            View What's On at Princess Theatre
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrincessWhatsOnSection;
